import { Dialog } from '@radix-ui/themes';
import CreateAccount from './CreateAccount.jsx';

import styles from './sign_in.module.css';

export const CreateAccountModal = ({ redirectParam, showSignInOption }) => {
  return (
    <Dialog.Content
      className={styles.dialogContent}
      maxWidth="400px"
      style={{ padding: '0px' }}
    >
      <CreateAccount
        redirectParam={redirectParam}
        isModal={true}
        showSignInOption={showSignInOption}
      />
    </Dialog.Content>
  );
};
